var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hr',{staticClass:"divider",class:_vm.customClasses,style:(_vm.cssVars)})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/cpmec.stagingwebsite.dev/web/app/themes/cpmec/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/cpmec.stagingwebsite.dev/web/app/themes/cpmec/node_modules/vue-loader/lib?{}!./scripts/vue/PageDivider.vue?vue&type=template&id=65d27d48&scoped=true&
// module id = 242
// module chunks = 0